// extracted by mini-css-extract-plugin
export default {"container":"styles_container__y2T-S","index":"styles_index__h2mE0","heading":"styles_heading__hGytb","line":"styles_line__r7Kcx"};